<template>
  <footer>
    <div class="footerContent">
      <iframe
        id="footer-iframe"
        class="footerIframe"
        title="Sources de données et partenaires"
        :src="footerUrl"
      />
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      footerUrl: `${process.env.VUE_APP_FRONT_PUBLIC_URL}/lab-footer`,
    };
  },
};
</script>

<style scoped>
.footerContent {
  padding-top: 1rem;
}

.footerIframe {
  border: none;
  width: 100%;
  height: 400px;
}
</style>
